import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-np_phone",
  "use": "icon-np_phone-usage",
  "viewBox": "0 0 22.239 22.239",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.239 22.239\" id=\"icon-np_phone\">\n  <path id=\"icon-np_phone_np_phone_5518539_000000\" d=\"M11.182,8.136l3.976,3.976a.548.548,0,0,1,.029.743c-.682.8-1.723,2.012-2.256,2.656a1.624,1.624,0,0,0-.359,1.349.67.67,0,0,0,.02.078,12.868,12.868,0,0,0,3.282,4.635,12.17,12.17,0,0,0,5.16,3.326.481.481,0,0,0,.067.014,1.636,1.636,0,0,0,1.409-.461l2.106-2.106a.544.544,0,0,1,.772,0l3.919,3.919a.547.547,0,0,1,0,.773c-.57.569-1.364,1.363-2.062,2.058h0a3.821,3.821,0,0,1-3.536,1.027,21.862,21.862,0,0,1-10.338-6.045A21.931,21.931,0,0,1,7.32,13.738,3.827,3.827,0,0,1,8.348,10.2L10.41,8.136a.547.547,0,0,1,.772,0Z\" transform=\"translate(-7.228 -7.977)\" fill=\"#202020\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/np_phone.svg
// module id = 153
// module chunks = 0 1 2